import { useLang } from "@/i18n";

/** Display names per language. Keys are the canonical category values stored in MongoDB. */
export const CATEGORY_LABELS = {
  "Food & Beverage": { ms: "Kedai Makan & Restoran", en: "Restaurants & Cafes" },
  Automotive: { ms: "Bengkel Kereta", en: "Car Workshops" },
  Plumbing: { ms: "Tukang Paip & Plumber", en: "Plumbers" },
  Contractors: { ms: "Kontraktor & Renovasi", en: "Contractors & Renovation" },
  "Tuition Centers": { ms: "Pusat Tuisyen", en: "Tuition Centres" },
  Freelancers: { ms: "Freelancer & Perkhidmatan Bebas", en: "Freelancers" },
  "Beauty & Wellness": { ms: "Salon, Spa & Kecantikan", en: "Beauty, Salon & Wellness" },
  "Retail & Grocery": { ms: "Kedai Runcit & Peruncitan", en: "Retail & Grocery Shops" },
  "Electrical & Aircond": { ms: "Servis Elektrik & Aircond", en: "Electrical & Aircond Services" },
  "Printing & Design": { ms: "Percetakan & Reka Bentuk", en: "Printing & Design" },
  Penginapan: { ms: "Homestay & Penginapan", en: "Homestays & Accommodation" },
  "Majlis & Perkahwinan": { ms: "Katering & Majlis Perkahwinan", en: "Catering & Wedding Services" },
  "Lain-lain": { ms: "Perniagaan Lain", en: "Other Services" },
};

export const categoryLabel = (category, lang) =>
  CATEGORY_LABELS[category]?.[lang] || category || "";

/** Translates a stored category value into the active language. */
export const useCategoryLabel = () => {
  const lang = useLang();
  return (category) => categoryLabel(category, lang);
};
